import { useUserDetailProfile } from './hooks';
import { convertToPresentationProps } from './logics';
import { UserDetailProfilePresentation } from './presentations';

type Props = {
  /** 利用者ID */
  userId: number;
};

/**
 * 利用者詳細プロフィール Container
 *
 * - API から利用者情報を取得してプロフィールとして表示する
 * - アクティベーションコード UI の表示可否（isActivationCodeEnabled）は convertToPresentationProps が
 *   enableStaging・PartnerFeatureFlag から導出する。Container は useUserDetailProfile の state
 *   （enableStaging / partnerFeatureFlagsData）を渡すだけ（MMT-156 リファクタ）
 * - カスタムフィールドはプロフィール API の custom_field_values をそのまま使って表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const UserDetailProfile: React.FC<Props> = ({ userId }) => {
  const {
    state: { data, profileData, enableStaging, partnerFeatureFlagsData },
  } = useUserDetailProfile(userId);

  const {
    fullName,
    email,
    clientName,
    billableFromLabel,
    createdAtLabel,
    updatedAtLabel,
    editLink,
    activationCode,
    phoneNumber,
    customFields,
    isActivationCodeEnabled,
  } = convertToPresentationProps({
    data,
    userId,
    profileData,
    enableStaging,
    partnerFeatureFlagsData,
  });

  return (
    <UserDetailProfilePresentation
      fullName={fullName}
      email={email}
      clientName={clientName}
      billableFromLabel={billableFromLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
      editLink={editLink}
      isActivationCodeEnabled={isActivationCodeEnabled}
      activationCode={activationCode}
      phoneNumber={phoneNumber}
      customFields={customFields}
    />
  );
};
